export default __webpack_public_path__ + "static/media/pravila-ustanovleniya-kvoti.f90e4412.pdf";